import { render } from "./KentNisse.vue?vue&type=template&id=6a0b9d30&scoped=true"
import script from "./KentNisse.vue?vue&type=script&lang=js"
export * from "./KentNisse.vue?vue&type=script&lang=js"

import "./KentNisse.vue?vue&type=style&index=0&id=6a0b9d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0b9d30"]])

export default __exports__